import { Layer } from 'react-map-gl';
import {
  POINTS_SOURCE_ID,
  SELECTED_POINT_LAYER_ID,
  SINGLE_POINT_LAYER_ID,
} from './constants';

/**
 * The Layer responsible for displaying single points on the map
 */
export const SinglePointLayer = () => {
  return (
    <Layer
      id={SINGLE_POINT_LAYER_ID}
      beforeId={SELECTED_POINT_LAYER_ID}
      type='circle'
      source={POINTS_SOURCE_ID}
      filter={['!', ['has', 'point_count']]}
      paint={{
        'circle-color': ['get', 'color'],
        'circle-radius': ['interpolate', ['linear'], ['zoom'], 16, 4, 24, 9],
      }}
    />
  );
};
